<script setup lang="ts">
import PrimaryButton from '@/components/common/PrimaryButton.vue';
import ModalDialogV2 from '@/components/common/ModalDialogV2.vue';
import { useCurrentEcommerce } from '@/modules/flokee/composables/useCurrentEcommerce';

const { t } = useTranslations();
const router = useRouter();
const open = defineModel<boolean>({
  required: true,
});
const { dashboardRouteName } = useBusinessUnitResolver();
const { isGoogleMerchantWizardDone } = useCurrentEcommerce();

// Nothing left to set up: skip the modal and land on the dashboard.
watch(open, (isOpen) => {
  if (!isOpen || !isGoogleMerchantWizardDone.value) return;
  open.value = false;
  router.push({ name: dashboardRouteName.value });
});
</script>

<template>
  <ModalDialogV2 centered v-model="open" static size="lg">
    <template #default>
      <img class="mx-auto mb-5 w-full max-w-32" src="/images/robot/robot-happy.png" alt="" />
      <h3 class="mb-3 text-center text-2xl font-medium">
        {{ t('cart_checkout.flokee.checkout_completed_modal.title') }}
      </h3>
      <h3 class="mb-3 text-lg font-medium">
        {{ t('cart_checkout.flokee.checkout_completed_modal.subtitle') }}
      </h3>
      <p>
        {{ t('cart_checkout.flokee.checkout_completed_modal.description') }}
      </p>
    </template>
    <template #footer>
      <PrimaryButton
        @click="router.push({ name: 'StoreConnectionsMerchantSetupView' })"
        class="mx-auto w-full max-w-sm"
        type="button"
      >
        {{ t('cart_checkout.flokee.checkout_completed_modal.button') }}
      </PrimaryButton>
      <p
        class="mt-1 flex items-center justify-center text-[0.8em] leading-7 text-semantic-text-secondary"
      >
        <IconifyIcon class="mr-1 size-5 text-inherit" icon="heroicons:exclamation-triangle" />
        {{ t('cart_checkout.flokee.checkout_completed_modal.button_hint') }}
      </p>
    </template>
  </ModalDialogV2>
</template>
